import { render } from "./NotificationManagement.vue?vue&type=template&id=ccac0b36&scoped=true"
import script from "./NotificationManagement.vue?vue&type=script&lang=js"
export * from "./NotificationManagement.vue?vue&type=script&lang=js"

import "./NotificationManagement.vue?vue&type=style&index=0&id=ccac0b36&lang=css"
import "./NotificationManagement.vue?vue&type=style&index=1&id=ccac0b36&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccac0b36"]])

export default __exports__